module.exports = __webpack_public_path__ + "static/media/CIAJ1-01.bfdefe71.png";